import { FieldValidatorType } from "@progress/kendo-react-form";

const regex = new RegExp(/^[a-z0-9]+$/i);

export const alfaNumericValidator: FieldValidatorType = (value: string) =>
  (regex.test(value) || value==="")
    ? ""
    : "Il campo deve essere composto da caratteri alfanumerici";
